export const newBuild = {
    preUrl: 'Unable to locate your address, if this is a new build ',
    postUrl: '. If it\'s not then please fill in the form below',
    button: 'CLICK HERE',
};